import { useState, useEffect } from "react";
import { formatearFecha, getTextoDesplegableSeleccionado, validarFormRegistroPaciente } from "./ModalFormPaciente-Utils";
import { getTiposDocumento as obtenerTiposDocs, getMutuales as obtenerMutuales, registrarPaciente as crearPaciente, actualizarPaciente, getPaciente as buscarPaciente } from "../../../apiClient/rutes/paciente";
export const usePacienteForm = ({ paciente, setPaciente, setOpenModal, mostrarNotificacion, openModal }) => {
  // Estados
  const [cargando, setCargando] = useState(false);
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [correo, setCorreo] = useState("");
  const [fechaNac, setFechaNac] = useState("");
  const [celular, setCelular] = useState("");
  const [nroDocumento, setNroDocumento] = useState("");
  const [tiposDoc, setTiposDoc] = useState([]);
  const [mutuales, setMutuales] = useState([]);
  const [mutualAfiliado, setMutualAfiliado] = useState("");
  const [tipoDoc, setTipoDoc] = useState(-1);
  const [mutual, setMutual] = useState(-1);
  const [errores, setErrores] = useState({});
  const [abrirModalCancelarRegistro, setAbrirModalCancelarRegistro] = useState(false);
  const [abrirDesplegableTiposDoc, setAbrirDesplegableTiposDoc] = useState(false);
  const [abrirDesplegableMutuales, setAbrirDesplegableMutuales] = useState(false);
  const [abrirDialogoReiniciarSesion, setAbrirDialogoReiniciarSesion] = useState(false);
  const [error, setError] = useState(false);

  // Helpers
  const limpiarCampos = () => {
    setNombre(""); setApellido(""); setFechaNac(""); setTipoDoc(-1);
    setNroDocumento(""); setMutual(-1); setMutualAfiliado(""); setCelular(""); setCorreo("");
  };

  const traerTiposDocs = async () => {
    try {
      const tiposDocs = await obtenerTiposDocs();
      setTiposDoc(tiposDocs);
    } catch (e) {
      mostrarNotificacion(true, "Ha ocurrido un error al intentar cargar los tipos de documentos", "rojo");
    }
  };

  const traerMutuales = async () => {
    try {
      const mutuales = await obtenerMutuales();
      setMutuales(mutuales);
    } catch (e) {
      mostrarNotificacion(true, "Ha ocurrido un error al intentar cargar las mutuales registradas", "rojo");
    }
  };

  useEffect(() => {
    if (paciente?.codigo && mutuales.length === 0) {
      traerTiposDocs(); traerMutuales();
    }
    if (paciente?.codigo && mutuales.length !== 0 && openModal) {
      setNombre(paciente.nombre);
      setApellido(paciente.apellido);
      setCorreo(paciente.email);
      if (paciente.nacimiento) {
        const fechaBackend = paciente.nacimiento.split("T")[0];
        const [year, month, day] = fechaBackend.split("-");
        setFechaNac(`${day}/${month}/${year}`);
      } else {
        setFechaNac("");
      }
      setCelular(paciente.celular);
      setNroDocumento(paciente.documentoNro);
      setMutualAfiliado(paciente.mutualAfiliado);
      setTipoDoc(paciente.documentoTipo);
      setMutual(paciente.mutual);
    }
    if (!openModal) limpiarCampos();
    // eslint-disable-next-line
  }, [openModal, paciente, mutuales]);

  const handleChangeSelect = (value, select) => {
    switch (select) {
      case "Obra social": setMutual(value); break;
      case "Tipo Documento": setTipoDoc(value); break;
      default: mostrarNotificacion(true, "Seleccion invalida", "rojo"); break;
    }
  };

  const handleFechaChange = (e) => {
    const valorFormateado = formatearFecha(e.target.value);
    setFechaNac(valorFormateado);
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    setError(valorFormateado.length === 10 && !regex.test(valorFormateado));
  };

  const handleClickRegistrarPaciente = async () => {
    const { pasa, errors } = validarFormRegistroPaciente({nombre, apellido, fechaNac, celular, nroDocumento, correo, tipoDoc});
    setErrores(errors);
    if (pasa) {
      if (paciente?.codigo) {
        await modificarPaciente();
      } else {
        await registrarPaciente(paciente?.token);
      }
    }
  };

  const registrarPaciente = async () => {
    try {
      const response = await crearPaciente({
        hc: nroDocumento,
        documentoNro: nroDocumento,
        documentoTipo: tipoDoc,
        documentoTipoNombre: getTextoDesplegableSeleccionado(tiposDoc, tipoDoc),
        nombre, apellido, mutual: 1, mutualNombre: "Particular", celular, email: correo, mutualAfiliado: "-", nacimiento: fechaNac, password: nroDocumento,
      }, tiposDoc, mutuales, paciente?.token);
      mostrarNotificacion(true, "Usuario registrado correctamente", "verde");
      limpiarCampos(); setOpenModal(false);
    } catch (error) {
      if (error?.response?.status === 400) {
        mostrarNotificacion(true, "No se ha podido registrar el nuevo usuario debido a: " + error.response.data, "rojo");
      } else {
        mostrarNotificacion(true, "Error: " + error?.response?.data, "rojo");
      }
    }
  };

  const modificarPaciente = async () => {
    const convertirFormatoFecha = (fecha) => {
      const [dia, mes, año] = fecha.split("/");
      return `${mes}/${dia}/${año}`;
    };
    const fechaConvertida = convertirFormatoFecha(fechaNac);
    try {
      const response = await actualizarPaciente({
        codigo: paciente.codigo,
        hc: paciente.hc,
        documentoNro: nroDocumento,
        documentoTipo: tipoDoc,
        documentoTipoNombre: getTextoDesplegableSeleccionado(tiposDoc, tipoDoc),
        nombre, apellido, mutual, mutualNombre: getTextoDesplegableSeleccionado(mutuales, mutual), celular: +celular, email: correo, mutualAfiliado: mutual !== 1 ? mutualAfiliado : "-", nacimiento: fechaConvertida, password: nroDocumento,
      }, paciente?.token);
      mostrarNotificacion(true, "Usuario modificado correctamente", "verde");
      await obtenerPaciente();
    } catch (error) {
      if (error?.response?.status === 400) {
        mostrarNotificacion(true, "No se ha podido modificar el usuario debido a: " + error.response.data, "rojo");
      } else {
        mostrarNotificacion(true, "Error: " + error?.response?.data, "rojo");
      }
    }
  };

  const obtenerPaciente = async () => {
    let sesion = JSON.parse(sessionStorage.getItem("ppUL"));
    try {
      const data = await buscarPaciente(nroDocumento, paciente.token);
      sesion = { ...sesion, ...data };
      setPaciente(sesion);
      setOpenModal(false);
    } catch (error) {
      mostrarNotificacion(true, "Se produjo un error al intentar consultar los datos del paciente", "rojo");
    }
  };

  const confirmarCancelarRegistro = () => { limpiarCampos(); setOpenModal(false); };
  const togleAbrirCerrarCancelarRegistro = () => {
    if (paciente?.codigo) {
      window.location.href = "/portal/Inicio";
      confirmarCancelarRegistro();
    } else {
      setAbrirModalCancelarRegistro(true);
    }
  };
  const handleClickConfirmar = () => { window.location.href = "/Login"; };

  return {
    cargando, setCargando,
    nombre, setNombre,
    apellido, setApellido,
    correo, setCorreo,
    fechaNac, setFechaNac,
    celular, setCelular,
    nroDocumento, setNroDocumento,
    tiposDoc, setTiposDoc,
    mutuales, setMutuales,
    mutualAfiliado, setMutualAfiliado,
    tipoDoc, setTipoDoc,
    mutual, setMutual,
    errores, setErrores,
    abrirModalCancelarRegistro, setAbrirModalCancelarRegistro,
    abrirDesplegableTiposDoc, setAbrirDesplegableTiposDoc,
    abrirDesplegableMutuales, setAbrirDesplegableMutuales,
    abrirDialogoReiniciarSesion, setAbrirDialogoReiniciarSesion,
    error, setError,
    handleChangeSelect,
    handleFechaChange,
    handleClickRegistrarPaciente,
    togleAbrirCerrarCancelarRegistro,
    confirmarCancelarRegistro,
    handleClickConfirmar,
  };
};
